import CardBrand from '../../../../layouts/Card/cardContent/CardBrand';

export const listSettings = {
    grid : {
        components : CardBrand,
        columns : {
            xs : 1,
            sm : 2,
            md: 2,
            laptop : 3,
        }
    },
}

export const listMappers = [
    {
        view : 'card',
        mapper : null
    },
    // {
    //     view : 'table',
    //     mapper : 'companiesListMapper'
    // }
]

export const perPageOptions = {
    'card' : ['9'],
}